import useI18n from '@/shared/hooks/useI18n'
import { AuditLog } from '@/shared/hooks/api/auditLogs'
import { formatDistanceToNow, Locale } from 'date-fns'
import { enUS, de, fr, es } from 'date-fns/locale' // Import locales
import { useSession } from '@/shared/hooks/useSession'
import { TFunction } from 'i18next'
import { Trans } from 'react-i18next'

const getActivityMessage = (t: TFunction<'translation', undefined>, activity: AuditLog) => {
  const userFullName = `${activity.user?.firstName} ${activity.user?.lastName}`
  const message = (
    <Trans
      i18nKey={`organizationUsers:activities.list.${activity.eventType}.title`}
      values={{ ...activity.metadata, user: activity.user }}
      components={[<em key="0" />, <em key="1" />]}
    />
  )

  return (
    <span>
      {message}
      <br />
      {t('organizationUsers:activities.actionBy')}:{' '}
      <span className="font-semibold">{userFullName}</span>
    </span>
  )
}

export default function OrganizationActivityListItem({ activity }: { activity: AuditLog }) {
  const { t } = useI18n()
  const {
    session: { language }
  } = useSession()
  const locales: { [key: string]: Locale } = { en: enUS, de, fr, es }

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <div className="text-sm font-medium mr-4">
          <span>{getActivityMessage(t, activity)}</span>
          <br />
        </div>
      </div>
      <div>
        <span className="text-xs text-text-secondary">
          {formatDistanceToNow(new Date(activity.createdAt), {
            addSuffix: true,
            locale: locales[language] || enUS
          })}
        </span>
      </div>
    </div>
  )
}
